import React, { Fragment, useEffect, Component, FC } from 'react'
import Appbar from './Appbar'
import Sidenav from './Sidenav'
import Drawer from './Drawer'
import Player from '../player/Player'
import Lyrics from './modal/Lyrics'
import QueView from '../player/QueView'
import PlaylistsModal from './modal/PlaylistsModal'
import TrackModal from './modal/TrackModal'
import Create from '../create/Create'
import Loader from './Loader'
import { connect } from 'react-redux'
import { getData } from '../../store/actions/songs'
import { getPlaylists, getMyPlaylists } from '../../store/actions/playlist'
import UploadsModal from './modal/UploadsModal'
import { RootState } from '../../store/reducers'
import { User } from '../../models/user'
import { getUsers } from '../../store/actions/users'
import AlbumModal from './modal/AlbumModal'

interface Props {
  children: Component
  user: User
  getData: Function
  getPlaylists: Function
  getMyPlaylists: Function
  getUsers: Function
  isAuthenticated: boolean
}

const MainApp: FC<Props> = ({
  children,
  user,
  getData,
  getPlaylists,
  getMyPlaylists,
  getUsers,
  isAuthenticated,
}) => {
  useEffect(() => {
    getData()
    getPlaylists()
    getUsers()
    window.scrollTo(0, 0)
    if (user && user.username) {
      getMyPlaylists(user.username)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <Fragment>
      <div className="app">
        <Sidenav />
        <Drawer />
        <QueView />
        <Lyrics />
        <TrackModal />
        <Loader />
        {user && isAuthenticated && (
          <Fragment>
            <PlaylistsModal />

            {user.accountType === `artist` && (
              <>
                <Create />
                <UploadsModal />
                <AlbumModal />
              </>
            )}
          </Fragment>
        )}

        <div className="app-content">
          <Appbar />
          <div className="nba"></div>
          <div>{children}</div>

          <div className="player">
            <Player />
          </div>
        </div>
      </div>
    </Fragment>
  )
}

const mapState = (state: RootState) => ({
  user: state.auth.user,
  current: state.songs.current,
  isAuthenticated: state.auth.isAuthenticated,
})

export default connect(mapState, {
  getData,
  getPlaylists,
  getMyPlaylists,
  getUsers,
})(MainApp)
